import { API_URL } from "../constants";
import { getHeaders } from "../utils";

export const getUsers = async () => {
  const response = await fetch("", {
    method: "GET",
    headers: getHeaders(),
  });
  return response.json();
};

export const addUser = async () => {
  const response = await fetch("", {
    method: "GET",
    headers: getHeaders(),
  });
  return response.json();
};

export const removeUser = async () => {
  const response = await fetch("", {
    method: "GET",
    headers: getHeaders(),
  });
  return response.json();
};

export const getUserInvites = async (email) => {
  const response = await fetch(`${API_URL}/api/user-invites/?email=${email}`, {
    method: "GET",
    headers: getHeaders(),
  });
  return response.json();
};
